import { render, staticRenderFns } from "./lyc_details.vue?vue&type=template&id=bdc1a604&"
import script from "./lyc_details.vue?vue&type=script&lang=js&"
export * from "./lyc_details.vue?vue&type=script&lang=js&"
import style0 from "./lyc_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports